module.exports = __webpack_public_path__ + "img/color.dcec2f3f.png";